import {Chart} from 'angular-highcharts';
import {Component} from '@angular/core';
import {BaseChartComponent} from '@rsp/shared/component/graph/base-chart.component';
import {CustomersEnergyDataDTO, CustomersEnergyDatasDTO} from '@rsp/models/dto/customers-energy-data.dto';
import * as Highcharts from 'highcharts';
import {SeriesLineOptions} from 'highcharts';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';


enum SeriesEnum {
  ENTNAHME = 'entnahme',
  EIGENERZEUGUNG = 'eigenerzeugung',
  EINSPEISUNG = 'einspeisung'
}

@Component({
  selector: 'rsp-strombilanz-energie-stroeme-chart',
  templateUrl: '../base-chart.component.html',
})

export class StrombilanzEnergieStroemeChartComponent extends BaseChartComponent<CustomersEnergyDatasDTO> {


  constructor(private userTracker: UserTrackingService) {
    super();
  }


  render() {
    super.render();

    const provide = [];
    const consumption = [];
    const selfsufficiency = [];

    for (let i = 0, l = this.data.values.length; i < l; i++) {
      const energyDataDTO: CustomersEnergyDataDTO = this.data.values[i];
      const timestamp = new Date(energyDataDTO.timestamp).getTime();

      const overlength = energyDataDTO[98] !== null;
      const underlength = energyDataDTO[94] === null;


      for (let j = 0; j < energyDataDTO.values.length; j++) {

        const value = energyDataDTO.values[j];


        let index = j;

        if (overlength && index >= 12 && index < 16) {
          index = index - 4;
        }

        const nTime = timestamp + index * 900 * 1000;
        // const nTime = timestamp;

        let destination;

        switch (energyDataDTO.energyDirection) {
          case 'Einspeisung':
            destination = provide;
            break;

          case 'Entnahme':
            destination = consumption;
            break;

          case 'Eigenerzeugung':
            destination = selfsufficiency;
            break;
        }
        destination.push([nTime, value]);
      }
    }
    const options: Highcharts.Options = this.createChartOptions();
    const series0First: boolean = this.sum(provide) < this.sum(consumption) ? true : false;

    (<SeriesLineOptions>options.series[0]).data = provide;
    (<SeriesLineOptions>options.series[0]).zIndex = series0First ? 1 : 0;

    (<SeriesLineOptions>options.series[1]).data = consumption;
    (<SeriesLineOptions>options.series[1]).zIndex = series0First ? 0 : 1;

    // (<SeriesLineOptions>options.series[2]).data = selfsufficiency;

    options.exporting.enabled = this._enableExport;

    this.chart = new Chart(options);
  }


  protected createChartOptions(): Highcharts.Options {
    return {
      chart: {
        type: 'area',
        zoomType: 'x',
      },
      series: [
        {
          id: SeriesEnum.EINSPEISUNG,
          type: 'area',
          data: [],
          name: 'Erzeugung',
          color: this.color1,
          events: {
            hide: (e) => {
              this.userTracker.trackEvent('Meine Energieströme Diagramm', 'Ausblenden', (<HTMLInputElement>e.target).name);
            },
            show: (e) => {
              this.userTracker.trackEvent('Meine Energieströme Diagramm', 'Einblenden', (<HTMLInputElement>e.target).name);
            }
          }
        },
        {
          id: SeriesEnum.ENTNAHME,
          type: 'area',
          data: [],
          name: 'Verbrauch',
          color: this.color2,
          events: {
            hide: (e) => {
              this.userTracker.trackEvent('Meine Energieströme Diagramm', 'Ausblenden', (<HTMLInputElement>e.target).name);
            },
            show: (e) => {
              this.userTracker.trackEvent('Meine Energieströme Diagramm', 'Einblenden', (<HTMLInputElement>e.target).name);
            }
          }
        }
      ],
      xAxis: {
        tickInterval: 24 * 3600 * 1000, // one week
        tickWidth: 0,
        gridLineWidth: 1,
        type: 'datetime',
        crosshair: true,
        events: {
          afterSetExtremes: (e) => {
            this.userTracker.trackEvent('Meine Energieströme Diagramm', 'Zoom');
          }
        },
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          format: '{value} kW'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
        margin: 0
      },

      plotOptions: {
        line: {
          step: undefined,
          marker: {
            enabled: false
          },
        },
        series: {
          marker: {
            enabled: false,
            radius: 2,
          },
          dataGrouping: {enabled: true},
        },
      },


      // 22.05.2019 ASe
      // In the tooltip the date is displayed together with a wrong weekday (all of a sudden)
      // Like Sunday 18-05.2019. Last sunday was however 19.0.2019
      // TODO: Needs to be investigated, for now I remove the wekday from format-
      tooltip: {

        pointFormatter: function () {
          return BaseChartComponent.pointFormatter(this, 'kW');
        },
        shared: true,
      },
      exporting: {
        enabled: true,
      },

    };
  }

  private sum(values: any[]): number {

    return values.reduce((acc, cur) => {
      acc += cur[1];
      return acc;
    }, 0);
  }
}
